import { Row } from "PFApp/booking/types";
import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import React, { JSX } from "react";

import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import css from "../side_panel_rows.module.scss";
import { checkIsLastLevel } from "./side_panel_row.utils";

type RowExpanderProps = {
  row: Row;
  onClick: VoidFunction;
  disabled: boolean;
  expanded: boolean;
};

export const RowExpander = ({ row, onClick, disabled, expanded }: RowExpanderProps): JSX.Element | null => {
  const { calendarMode } = useBookingsOverviewContext();
  const isLastLevel = checkIsLastLevel(calendarMode, row);

  return (
    <Button kind="blank" onClick={onClick} disabled={disabled || isLastLevel} className={css.expander}>
      <Icon
        name={expanded ? "chevron-down" : "chevron-right"}
        size="sm"
        color="paletteBlue0"
        className={css.icon}
      />
    </Button>
  );
};
